import React, { useEffect, useRef } from 'react';

// Live mic level without React re-renders (writes the width directly each frame).
export const LevelBar = ({ meter, className = 'iv-meter', scale = 6, testId }) => {
  const bar = useRef(null);
  useEffect(() => {
    if (!meter) return undefined;
    let raf;
    const tick = () => {
      if (bar.current) bar.current.style.width = `${Math.min(100, meter.read() * scale * 100)}%`;
      raf = requestAnimationFrame(tick);
    };
    tick();
    return () => cancelAnimationFrame(raf);
  }, [meter, scale]);
  return <div className={className} data-testid={testId}><i ref={bar} style={{ width: 0 }} /></div>;
};
